import { ObendyRoute } from '@core/app-routing';
import { hasLoginTokenGuard } from '@core/guards/has-login-token.guard';
import { isGuardianGuard } from '@core/guards/is-guardian.guard';
import { isLoggedGuard } from '@core/guards/is-logged.guard';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { GuardianChildrenRoutesEnum, GuardianRoutesEnum } from '@features/guardian/guardian-routing.enum';
import {
  childResolver,
  minorRegistrationPlanResolver,
  minorRegistrationResolver,
} from '@features/guardian/guardian.resolver';
import { configurableFieldsResolver } from '@features/profile/infos/configurable-fields.resolver';
import { partnerFoldersResolver } from '@features/profile/notifications/partner-folders.resolver';
import { userFoldersResolver } from '@features/profile/notifications/user-folders.resolver';

export const GUARDIAN_ROUTE: ObendyRoute = {
  path: FeaturesRoutingEnum.Guardian,
  title: 'Responsable légal',
  showInSiteMap: true,
  canActivate: [hasLoginTokenGuard, isLoggedGuard, isGuardianGuard],

  loadComponent: () => import('@features/guardian/guardian/guardian.component').then((cmp) => cmp.GuardianComponent),

  loadChildren: () => [
    {
      path: '',
      title: 'Responsable légal',
      showInSiteMap: false,

      children: [
        {
          path: GuardianRoutesEnum.Dashboard,
          showInSiteMap: true,
          title: 'Mes infos',
          loadComponent: () => import('@features/profile/infos/infos.component').then((cmp) => cmp.InfosComponent),
          resolve: {
            configurableFields: configurableFieldsResolver,
          },
        },

        {
          path: GuardianRoutesEnum.Notifications,
          showInSiteMap: true,
          title: 'Notifications',
          loadComponent: () =>
            import('@features/profile/notifications/notifications.component').then((cmp) => cmp.NotificationsComponent),
          resolve: { partnerFolders: partnerFoldersResolver, userFolders: userFoldersResolver },
        },

        {
          path: GuardianRoutesEnum.Children,
          showInSiteMap: true,
          title: 'Mes enfants',
          loadChildren: () => [
            {
              path: '',
              showInSiteMap: false,
              loadComponent: () =>
                import('@features/guardian/guardian-children/guardian-children.component').then(
                  (c) => c.GuardianChildrenComponent
                ),
            },
            {
              path: GuardianChildrenRoutesEnum.ChildId,
              showInSiteMap: false,
              loadComponent: () =>
                import('@features/guardian/register-child/register-child.component').then(
                  (c) => c.RegisterChildComponent
                ),
              resolve: { child: childResolver, minorRegistration: minorRegistrationResolver },
            },
            {
              path: GuardianChildrenRoutesEnum.UpdatePlan,
              showInSiteMap: false,
              loadComponent: () =>
                import('@features/guardian/register-child/register-child.component').then(
                  (c) => c.RegisterChildComponent
                ),
              resolve: { child: childResolver, minorRegistration: minorRegistrationPlanResolver },
            },
          ],
        },

        {
          path: '',
          showInSiteMap: false,
          redirectTo: GuardianRoutesEnum.Children,
          pathMatch: 'full',
        },
      ],
    },
  ],
};
